export default __webpack_public_path__ + "static/media/close.ce5409d7.svg";